import { IntlShape } from 'react-intl';
import { getColorMap } from '../constants/charts.constants';
import { Dataset, Option, Legend as LegendType } from '../models';

const nonHolidayLabelName = 'confirm-plan-charts.non-holiday-weekdays';

class ChartService {
  public static mapLabels(selectedOptionChartData: Option, intl: IntlShape) {
    const newOption = JSON.parse(JSON.stringify(selectedOptionChartData)) as Option;
    newOption.charts = newOption.charts.map((chart) => {
      const newChart = chart;
      // Swap out chart labels
      if (newChart.labels[0] !== '') {
        newChart.labels = newChart.labels.map((label) => intl.formatMessage({ id: label }));
      }
      // Swap out dataset labels
      newChart.datasets.forEach((dataset) => {
        ChartService.mapNewDatasets(dataset, intl);
      });
      return newChart;
    });
    return newOption;
  }

  private static mapNewDatasets(dataset: Dataset, intl: IntlShape) {
    const newDataset: Dataset = dataset;
    if (dataset.label !== 'None' && dataset.label !== '') newDataset.label = intl.formatMessage({ id: dataset.label });
    else newDataset.label = dataset.label;

    if (typeof newDataset.backgroundColor === 'string') {
      const colorCategory = newDataset.backgroundColor.split('.').pop();
      if (colorCategory) {
        newDataset.backgroundColor = ChartService.getMappedColor(colorCategory);
      }
    } else if (Array.isArray(newDataset.backgroundColor)) {
      newDataset.backgroundColor = newDataset.backgroundColor.map((color) => {
        const colorCategory = color.split('.').pop();
        if (!colorCategory) return '';
        return ChartService.getMappedColor(colorCategory);
      });
    }
  }

  public static mapLegends(selectedOptionChartData: Option, intl: IntlShape): LegendType[][] {
    return selectedOptionChartData.charts.map((chart) => {
      const legend: LegendType[] = [];
      chart.datasets.forEach((dataset) => {
        const newObj = ChartService.getNewLegendObj(dataset, legend, intl, selectedOptionChartData.optionLabel);
        if (newObj.color !== '' && newObj.label !== '') legend.push(newObj);
      });
      return legend;
    });
  }

  private static getNewLegendObj(dataset: Dataset, legend: LegendType[], intl: IntlShape, optionLabel: string): LegendType {
    const newObj: LegendType = { label: '', color: '' };
    if (legend.filter((e) => e.label.includes(dataset.label)).length !== 0 || dataset.label === 'None') return newObj;
    if (Array.isArray(dataset.backgroundColor)) {
      newObj.label = dataset.label;
      [newObj.color] = dataset.backgroundColor;
    } else {
      newObj.color = dataset.backgroundColor;
      if (dataset.label === intl.formatMessage({ id: 'confirm-plan-charts.peak-monthly' })) {
        newObj.label = `${dataset.label}: $${dataset.data[1].toFixed(2)}/${intl.formatMessage({ id: 'confirm-plan-charts.per-month' })}`;
      } else {
        newObj.label = `${dataset.label}: $${dataset.data[1].toFixed(2)}
        ${optionLabel === nonHolidayLabelName ? '/kW' : '/kWh'}`;
      }
    }
    return newObj;
  }

  public static getMappedColor(colorCategory: string) {
    const color = getColorMap().get(colorCategory);
    if (!color) throw new Error(`The color ${colorCategory} doesn't exist.`);
    return color as any;
  }
}

export { ChartService };
